/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router-dom';

import getVenuesList from '../../../../api/graphql/queries/getVenuesList';

import ModifyArray from '../../../Form/ModifyArray';
import AutocompleteArray from '../../../Form/AutocompleteArray';


const MapModule = ({
  handlerSetComponents, components, id, reusableComponent, reusableComponentSlugname, history,
}) => {
  const initialState = {
    type: 'Map',
    markers: [],
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isLoading, setLoading] = useState(true);
  const [venueSlugNames, setVenueSlugNames] = useState([]);
  const [venuesQueryList, setVenuesQueryList] = useState([]);
  const [subVenuesArray, setSubVenuesArray] = useState([]);
  const [showVenues, setShowVenues] = useState(false);

  useEffect(() => {
    getVenuesList().then(async (venuesData) => {
      if (venuesData) {
        if (venuesData.isAuth) {
          console.log(venuesData.venues);
          const venuesSlugNamesFromQuery = venuesData.venues.map(i => i.venueSlugName);
          await setVenueSlugNames(venuesSlugNamesFromQuery);
          await setVenuesQueryList(venuesData.venues);
          setLoading(false);
        } else {
          console.log('getVenuesList - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('venuesData = null');
      }
    });
  }, []);

  useEffect(() => {
    if (!isLoading) {
      const componentIndex = components.findIndex(obj => obj.id === id);

      const { component } = components[componentIndex];
      if (reusableComponent) {
        setState(reusableComponent);
        if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
      } else {
        setIndex(componentIndex);
        if (component) {
          setState(component);
          const arr = component.markers.map(venue => venue.venueSlugName);
          setSubVenuesArray(arr);
          // need to remove the selected items from the original list
          // https://stackoverflow.com/questions/48269545/javascript-remove-multiple-values-of-array-of-objects/48269610
          const lessSlugNames = venueSlugNames.filter(va => !arr.includes(va));
          setVenueSlugNames(lessSlugNames);
        } else {
          const componentObj = {
            id,
            component: state,
          };
          handlerSetComponents(componentObj, componentIndex);
        }
      }
    }
  }, [components, isLoading]);

  const storeArray = (name, value) => {
    const addingVenuesArray = [...subVenuesArray, value];
    setSubVenuesArray(addingVenuesArray);
    const lessVenues = venueSlugNames.filter(i => i !== value.toLowerCase());
    setVenueSlugNames(lessVenues);
  };

  const handleUpdatedSubArray = (name, arr, item) => {
    // add new selected venues arr after removal
    setSubVenuesArray(arr);
    // bring back the unselected venues to the list of available slugNames so the user can re-select them
    if (item) {
      const updatedVenuesSlugNames = [...venueSlugNames, item.toLowerCase()].sort((a, b) => (a > b ? 1 : b > a ? -1 : 0));
      setVenueSlugNames(updatedVenuesSlugNames);
    }
  };

  useEffect(() => {
    if (components && index >= 0) {
      const { component } = components[index];
      const markersArr = [];
      // Convert the array of selected objects into the format the Map component expects:
      subVenuesArray.forEach((v) => {
        const item = venuesQueryList.find(venueFromQuery => venueFromQuery.venueSlugName === v);
        const itemWithCorrectkeys = (({
          venueName, address, venueSlugName, postUri, latitude, longitude,
        }) => ({
          name: venueName,
          address,
          venueSlugName,
          position: { lat: parseFloat(latitude || null), lng: parseFloat(longitude || null) },
          web: `/${postUri}`,
        }))(item);
        markersArr.push(itemWithCorrectkeys);
      });

      console.log('markersArr', markersArr);

      const comp = {
        ...component,
        markers: markersArr,
      };

      console.log('comp!', comp);

      const componentObj = {
        id,
        component: comp,
      };

      handlerSetComponents(componentObj, index);
    }
  }, [subVenuesArray]);

  let divHeight;
  const showAvailableVenues = (display, height) => {
    setShowVenues(display);
    divHeight = height;
    return divHeight;
  };
  return (
    <div>
      <div className={`w-full pl-4 bg-greyFilter rounded-lg pl-10 ml-1 pr-2 pt-2px ${showVenues && `h-${divHeight}`}`}>
        {!isLoading && (
        <div className="w-full pl-4 pr-1 bg-greyFilter flex flex-row">
          <ModifyArray subArray={subVenuesArray} title="Venues" name="subVenuesArray" sendUpNewArray={handleUpdatedSubArray} textColor="black" map />
          <AutocompleteArray title="Add venues" textColor="black" name="venues" message="The venue does not exist" suggestions={venueSlugNames} showVenues={showAvailableVenues} storeArray={storeArray} action="create" value="" map />
        </div>
        )}
      </div>
    </div>
  );
};

MapModule.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape(),
  history: PropTypes.shape().isRequired,
};
MapModule.defaultProps = {
  reusableComponent: null,
};

export default withRouter(MapModule);
